import React from "react";
import { MRT_ColumnDef } from "material-react-table";
import { Tooltip, Box } from "@mui/material";
import dayjs from "dayjs";

import { toUSNumber, getDateFormat, isNullOrUndefined } from "utils";
import { EMPTY_CELL_VALUE } from "consts";

export const estimatesColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "estimateName",
    header: "Estimate Name",
  },
  {
    accessorKey: "utilityName",
    header: "Utility Type",
  },
  {
    accessorKey: "estimateType",
    header: "Estimate Type",
  },
  {
    accessorKey: "estimateHeadCount",
    header: "Estimation Value",
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;
      return (
        <Tooltip title={value}>
          <Box>{toUSNumber(value)}</Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "estimateUsage",
    header: "Estimated Usage per Day",
    Header: <Box>Estimated Usage per Day</Box>,
    size: 240,
    Cell: ({ cell }: any) => {
      const value = cell.getValue();
      return (
        <Tooltip title={value}>
          <Box>{toUSNumber(value ?? 0)}</Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "estimateUsageUnit",
    header: "Consumption Unit",
  },
  {
    accessorKey: "estimateStartDate",
    header: "Start Date",
    accessorFn: (row) =>
      dayjs(row.estimateStartDate).utc().format(getDateFormat()),
  },
  {
    accessorKey: "estimateEndDate",
    header: "End Date",
    accessorFn: (row) =>
      dayjs(row.estimateEndDate).utc().format(getDateFormat()),
  },
  {
    accessorKey: "scope",
    header: "GHG Emissions",
  },
  {
    accessorKey: "estimateSource",
    header: "Estimate Source",
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;

      if (isNullOrUndefined(value)) {
        return EMPTY_CELL_VALUE;
      }

      return (
        <Tooltip title={value}>
          <Box>{value}</Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "notes",
    header: "Notes",
  },
];
